import {useEffect, useReducer} from "react";
import {add} from "date-fns";

import useDialog from "../../../hooks/useDialog";
import useCachedPrices from "../RatePlanner/useCachedPrices";
import useTimer from "../../../hooks/useTimer";


const initialState = {
    timeout: false,  // timeout is expired
    fired: false  // dialog has been already open for the current apartmentId
}

const useNoPriceDialog = (props) => {
    const {enabled, apartmentId, rate} = props

    const rateId = rate?.id;
    const basePeople = rate?.basePeople;

    const noPricesDialog = useDialog();
    const getCachedPrices = useCachedPrices();

    const [state, setState] = useReducer(
        (oldState, partialState) => ({
            ...oldState,
            ...partialState
        }),
        initialState)

    const [, restartTimer] = useTimer(
        () => setState({timeout: true}),
        2000
    )

    // Reset the state and the timer when the apartment changes
    useEffect(() => {
        setState(initialState);
        restartTimer();
    }, [restartTimer, apartmentId, rateId])

    // Open the dialog when the timeout is expired and the dialog is still enabled and not already opened
    useEffect(() => {
        if (state.timeout && !state.fired
            && apartmentId !== null && apartmentId !== undefined
            && rateId != null) {

            // set fired true even if it is not enabled, since the user might have already done
            // something (set the prices) so the dialog is no opened when it became again enabled
            setState({fired: true})

            if(enabled){
                // check if the prices are already present in the cache
                const data = getCachedPrices(apartmentId, rateId, new Date(), add(new Date(), {months: 24}));
                if (!data.pricesCent[basePeople] || data.pricesCent[basePeople].every((x) => x === null)) {
                    noPricesDialog.open();
                }
            }
        }
    }, [state.timeout, state.fired, enabled, apartmentId, rateId, basePeople])  // eslint-disable-line react-hooks/exhaustive-deps

    return noPricesDialog;
}

export default useNoPriceDialog;